var Gift = /** @class */ (function () {
    function Gift(obj, id) {
        if (id) {
            this.id = id;
        }
        this.bg_name = obj.bg_name;
        this.en_name = obj.en_name;
        this.brand = obj.brand;
        this.packaging = obj.packaging;
        this.status = obj.status;
        this.image_url = obj.image_url;
        this.external_id = obj.external_id;
        this.position = obj.position;
    }
    Object.defineProperty(Gift.prototype, "Id", {
        get: function () {
            return this.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Gift.prototype, "BgName", {
        get: function () {
            return this.bg_name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Gift.prototype, "EnName", {
        get: function () {
            return this.en_name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Gift.prototype, "Brand", {
        get: function () {
            return this.brand;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Gift.prototype, "Packaging", {
        get: function () {
            return this.packaging;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Gift.prototype, "Status", {
        get: function () {
            return this.status;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Gift.prototype, "Position", {
        get: function () {
            return this.position;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Gift.prototype, "ImageUrl", {
        get: function () {
            return this.image_url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Gift.prototype, "ExternalId", {
        get: function () {
            return this.external_id;
        },
        enumerable: false,
        configurable: true
    });
    return Gift;
}());
export { Gift };
export function createGift(obj, id) {
    return new Gift(obj, id);
}
export function createGifts(rawGifts) {
    var gifts = [];
    var rawGiftsData = rawGifts.data;
    for (var _i = 0, rawGiftsData_1 = rawGiftsData; _i < rawGiftsData_1.length; _i++) {
        var rawSample = rawGiftsData_1[_i];
        var sample = createGift(rawSample.attributes, rawSample.id);
        gifts.push(sample);
    }
    return gifts;
}



//////////////////
// WEBPACK FOOTER
// ./src/classes/definitions/gift/gift.ts
// module id = 118
// module chunks = 0